import { renderTopbar } from '../components/topbar.js';
import { renderCalendarHistory } from '../components/calendarHistory.js';
import { getMyQuizAttempts } from '../lib/quizScore.js';
import { friendlyError } from '../lib/friendlyError.js';

// "My Scores" (#/scores) — every signed-in learner's own quiz history, as a
// calendar of dates with a badge on any day they completed a quiz. Scores
// are recorded automatically whenever a generated page reports a completed
// attempt — see lib/quizScore.js's attachQuizScoreBridge and
// functions/systemPrompt.js's SCORE REPORTING instruction. There's nothing
// to set up: any topic that ends up presenting scored/checkable questions
// starts showing up here the first time it's completed.
export function renderScores(container) {
  container.innerHTML = '';
  container.appendChild(renderTopbar('/scores'));

  const main = document.createElement('div');
  main.className = 'main-full';
  main.innerHTML = `<div class="empty-state">Loading your scores…</div>`;
  container.appendChild(main);

  getMyQuizAttempts()
    .then((attempts) => {
      main.innerHTML = `
        <h1 style="margin-bottom:4px;">🗓️ My Scores</h1>
        <p style="color:var(--text-dim);margin-top:0;">Every quiz you've completed, by date.</p>
        ${attempts.length === 0
          ? '<div class="empty-state"><div style="font-size:2.5rem;">📊</div><h3>No quiz scores yet</h3><p>Complete a quiz in one of your topics and it will show up here.</p></div>'
          : '<div id="scores-calendar"></div>'}
      `;
      if (attempts.length > 0) {
        renderCalendarHistory(main.querySelector('#scores-calendar'), { attempts });
      }
    })
    .catch((err) => {
      main.innerHTML = `<div class="empty-state"><p>${friendlyError(err, 'Could not load your scores.')}</p></div>`;
    });

  return () => {};
}
